<template>
  <v-container fluid>
    <template v-if="driverDetails">
      <v-row wrap>
        <v-col cols="6" class="py-1">
          <DisplayField label="Name" :value="driverName" />
        </v-col>
        <v-col cols="6" class="py-1">
          <DisplayField label="DOB" :value="driverDetails.dateOfBirth" type="piiDate" />
        </v-col>
        <v-col cols="6" class="py-1">
          <DisplayField label="SR" :value="driverDetails.auto.sR22" type="bool" />
        </v-col>
        <v-col v-if="isPersonal" cols="6" class="py-1">
          <DisplayField label="Marital Status" :value="maritalStatus" />
        </v-col>
        <v-col v-if="isPersonal" cols="6" class="py-1">
          <DisplayField label="Relationship" :value="driverDetails.relationship" />
        </v-col>
        <v-col v-if="isPersonal" cols="6" class="py-1">
          <DisplayField label="Occupation" :value="driverDetails.occupation" />
        </v-col>
        <v-col cols="6" class="py-1">
          <DisplayField label="License Number" :value="maskedDl" />
        </v-col>
        <v-col v-if="isPersonal" cols="6" class="py-1">
          <DisplayField label="License State" :value="driverDetails.licenseState" />
        </v-col>
        <v-col v-if="isPersonal" cols="6" class="py-1">
          <DisplayField label="Education" :value="educationLevel" />
        </v-col>
        <v-col v-if="isCommercial" cols="6" class="py-1">
          <DisplayField label="Comp. Driver #" :value="driverDetails.companyDriverNumber" />
        </v-col>
      </v-row>
      <template v-if="viewingMore">
        <v-row class="pb-2" wrap>
          <v-col cols="6" class="py-1">
            <DisplayField label="Gender" :value="gender" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="SSN" :value="maskedSsn" />
          </v-col>
        </v-row>
        <v-divider />
        <v-row v-if="isPersonal" class="py-2" wrap>
          <v-col cols="12" class="section-header pt-0 pb-1">Driver Information</v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Operator Status" :value="operatorStatus" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Driver Training?" :value="driverDetails.auto.driverTraining" type="bool" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Course Date" :value="driverDetails.auto.driverTrainingDate" type="date" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Defensive Driver?" :value="driverDetails.auto.defensiveDriver" type="bool" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Course Date" :value="driverDetails.auto.defensiveDriverCourseDate" type="date" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Major CC?" :value="driverDetails.auto.majorCreditCard" type="bool" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Good Driver?" :value="driverDetails.auto.goodDriver" type="bool" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Good Student?" :value="driverDetails.auto.goodStudent" type="bool" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Student > 100 Miles?" :value="driverDetails.auto.studentOver100Miles" type="bool" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Living with Spouse?" :value="driverDetails.auto.livingWithSpouse" type="bool" />
          </v-col>
        </v-row>
        <v-divider />
        <v-row v-if="isCommercial" class="py-2" wrap>
          <v-col cols="12" class="section-header pt-0 pb-1">Driver Information</v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Drive Other Car" :value="driverDetails.auto.driveOtherCar" type="bool" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Broaden No Fault" :value="driverDetails.auto.broadenNoFault" type="boolc" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Date of CDL" :value="driverDetails.auto.dateOfCDL" type="date" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Hired Date" :value="driverDetails.auto.hiredDate" type="date" />
          </v-col>
        </v-row>
        <v-divider />
        <v-row v-if="driverDetails.auto.sR22" class="py-2" wrap>
          <v-col cols="12" class="section-header pt-0 pb-1">SR 22</v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Proof Required Until" :value="driverDetails.auto.sR22Date" type="date" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Reason" :value="driverDetails.auto.sR22Reason" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="State" :value="driverDetails.auto.sR22State" />
          </v-col>
        </v-row>
        <v-divider />
        <v-row class="py-2" wrap>
          <v-col cols="12" class="section-header pt-0 pb-1">Underwriting Questions</v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Military Service?" :value="driverDetails.auto.military" type="bool" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="DL Suspended?" :value="driverDetails.suspended" type="bool" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Impairments?" :value="driverDetails.auto.impaired" type="bool" />
          </v-col>
          <v-col cols="6" class="py-1">
            <DisplayField label="Prior Cov. Declined?" :value="driverDetails.auto.priorCoverageDeclined" type="bool" />
          </v-col>
        </v-row>
      </template>

      <v-row justify="end">
        <v-col cols="6" class="text-end">
          <a class="link" @click="toggleView">
            {{ viewMoreText }}
          </a>
        </v-col>
      </v-row>

    </template>
    <template v-else-if="!loading">
      <v-row>
        <v-col>
          Unable to get information. Please try again later.
        </v-col>
      </v-row>
    </template>

    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Loading driver details...
          <v-progress-linear indeterminate color="white" class="mb-0" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style scoped>
.section-header {
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    line-height: 12px;
    letter-spacing: 0.25px;
    text-transform: uppercase;
    color: #767676;
  }
</style>

<script>
import enumService from '@/services/shared/enumService.js';
import analyticsService from '@/services/shared/analyticsService.js';
import { mapState, mapActions } from 'vuex';

import DisplayField from '@/components/Shared/DisplayField.vue';

export default {
  name: 'AutoDetail',
  components: {
    DisplayField
  },
  props: {
    driverDetails: {
      type: Object,
      required: true
    },
    loading: Boolean
  },
  data: function () {
    return {
      viewingMore: false
    };
  },
  computed: {
    ...mapState(['selectedLineOfBusinessCode']),
    clientId: function () {
      return this.$route.params.clientId;
    },
    policyOrderNumber: function () {
      return this.$route.params.policyOrderNumber;
    },
    lobCode: function () {
      return this.selectedLineOfBusinessCode;
    },
    driverId: function () {
      return this.$route.params.driverId;
    },
    driverName () {
      return this.driverDetails.firstName + ' ' + this.driverDetails.lastName + ' ' + this.driverDetails.suffix;
    },
    isPersonal () {
      return this.driverDetails.auto.type === 1;
    },
    isCommercial () {
      return this.driverDetails.auto.type === 0;
    },
    viewMoreText: function () {
      return this.viewingMore ? 'View Less' : 'View More';
    },
    operatorStatus () {
      return enumService.operatorStatuses[this.driverDetails.auto.operatorStatus];
    },
    maritalStatus () {
      return enumService.maritalStatuses[this.driverDetails.maritalStatus];
    },
    gender () {
      return enumService.genders[this.driverDetails.gender];
    },
    educationLevel () {
      return enumService.educationLevels[this.driverDetails.educationLevel];
    },
    maskedSsn () {
      if ((this.driverDetails.lastFourSsn || null) === null) {
        return '';
      }
      return '*** - ** - ' + this.driverDetails.lastFourSsn;
    },
    maskedDl () {
      if ((this.driverDetails.licenseNumberLastTwo || null) === null) {
        return '';
      }
      return '********' + this.driverDetails.licenseNumberLastTwo;
    }
  },
  methods: {
    ...mapActions(['setError']),
    toggleView: function () {
      if (!this.viewingMore) {
        analyticsService.sendEvent(this.$gtag, 'Button Click', 'Policy', 'Auto Driver View More');
      }
      this.viewingMore = !this.viewingMore;
    }
  }
};
</script>
